import { Injectable } from '@angular/core';
import {AttributesApiService} from '../attributes/attributes-api.service';
import {HttpClient} from '@angular/common/http';
import {AttributeManipulationGroupsApiService} from '../../settings/call-flow-configurations/attribute-manipulation-groups/attribute-manipulation-groups-api.service';

@Injectable({
  providedIn: 'root'
})
export class ServersApiService {

  constructor(private http: HttpClient,
              private attributesApiService: AttributesApiService,
              private attributeManipulationGroupsApiService: AttributeManipulationGroupsApiService) { }

  readonly serversUrl: string = 'identity/server';

  getServers(): Promise<any> {
    return this.http.get(this.serversUrl).toPromise();
  }

  getServer(id): Promise<any> {
    return this.http.get(this.serversUrl + '/' + id).toPromise();
  }

  addServer(server): Promise<any> {
    return this.http.post(this.serversUrl, server).toPromise();
  }

  editServer(server): Promise<any> {
    const url = this.serversUrl + '/' + server.id;
    return this.http.put(url, server).toPromise();
  }

  deleteServer(id): Promise<any> {
    const url = this.serversUrl + '/' + id;
    return this.http.delete(url).toPromise();
  }

  testServer(server): Promise<any> {
    return this.http.post(this.serversUrl + '/test', server).toPromise();
  }

  prepareDataForServerAdd(ldapType: string): Promise<any> {
    const server = {name: '', password: null, host: '', port: 389, dn: '', searchFilter: 'objectClass=user',
      baseObject: '', pageSize: 1000, sslEnabled: false, certificate: '', syncIntervalMinutes: ldapType !== 'UMP' ? 5 : 15 ,
      fullSyncHour: 3, fullSyncMinute: 0, timeout: 60, readTimeout: ldapType !== 'UMP' ? 120 : 300, fullSyncIntervalInDays: 1,
      dicAttrMapping: []};

    return Promise.all([server, this.attributesApiService.getAttributes(),
      this.attributeManipulationGroupsApiService.getAttributeManipulationGroups().toPromise()]);
  }

  prepareDataForServerEdit(serverId: number): Promise<any> {
    return Promise.all([this.getServer(serverId), this.attributesApiService.getAttributes(),
      this.attributeManipulationGroupsApiService.getAttributeManipulationGroups().toPromise()]);
  }
}
